import { useEffect, useRef, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import { catchFunction } from "../../../../shared/lib/utils";
import OverviewTabContent from "../../../../shared/components/overview-panel/OverviewTabContent";
import DashboardsOverviewTable from "./DashboardsOverviewTable";
import OverviewComponent from "../../../../shared/components/overview-panel/OverviewComponent";
import SearchInput from "../../../../shared/components/input/SearchInput";
import { SECTIONS as API_SECTIONS } from "../../../../shared/lib/apiEndpointsResolver";
import { useTracking } from "react-tracking";
import useSectionSorting from "../shared/useSectionSorting";
import { useTranslation } from "react-i18next";

const DashboardsOverview = () => {
  const axios = useAxios();
  const [dashboards, setDashboards] = useState([]);
  const dashboardsRef = useRef([]);
  const { trackEvent } = useTracking();
  const sectionSorting = useSectionSorting();
  const { t } = useTranslation();

  const breadcrumbItems = [{ title: "dashboards.overview.breadcrumb.first" }];

  const findDashboards = () => {
    axios
      .get(API_SECTIONS, { params: { category: "dashboards" } })
      .then((response) => {
        const sortedData = response.data.sort(sectionSorting);
        setDashboards(sortedData);
        dashboardsRef.current = sortedData;
      })
      .catch(catchFunction);
  };

  const filterDashboardsByTitle = (changeEvent) => {
    setDashboards(
      dashboardsRef.current.filter((d) =>
        t(d.title)
          .toLowerCase()
          .includes(changeEvent.target.value.toLowerCase()),
      ),
    );
  };

  const SearchInputComponent = (
    <SearchInput
      onChangeHandler={filterDashboardsByTitle}
      placeholder="dashboards.overview.searchInputPlaceholder"
    />
  );

  const dashboardsTabs = [
    {
      trigger: { value: "all", label: "dashboards.overview.tabs.trigger.all" },
      content: (
        <OverviewTabContent
          value="all"
          title="dashboards.overview.card.all.title"
          description="dashboards.overview.card.all.description"
        >
          <DashboardsOverviewTable data={dashboards} />
        </OverviewTabContent>
      ),
    },
    {
      trigger: { value: "adq", label: "dashboards.overview.tabs.trigger.adq" },
      content: (
        <OverviewTabContent
          value="adq"
          title="dashboards.overview.card.adq.title"
          description="dashboards.overview.card.adq.description"
        >
          <DashboardsOverviewTable
            data={dashboards.filter((x) => x.type.code === "adq")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "powerbi",
        label: "dashboards.overview.tabs.trigger.powerbi",
      },
      content: (
        <OverviewTabContent
          value="powerbi"
          title="dashboards.overview.card.powerbi.title"
          description="dashboards.overview.card.powerbi.description"
        >
          <DashboardsOverviewTable
            data={dashboards.filter((x) => x.type.code === "powerbi")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "gdrive",
        label: "dashboards.overview.tabs.trigger.gdrive",
      },
      content: (
        <OverviewTabContent
          value="gdrive"
          title="dashboards.overview.card.gdrive.title"
          description="dashboards.overview.card.gdrive.description"
        >
          <DashboardsOverviewTable
            data={dashboards.filter((x) => x.type.code === "gdrive")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "lstudio",
        label: "dashboards.overview.tabs.trigger.lstudio",
      },
      content: (
        <OverviewTabContent
          value="lstudio"
          title="dashboards.overview.card.lstudio.title"
          description="dashboards.overview.card.lstudio.description"
        >
          <DashboardsOverviewTable
            data={dashboards.filter((x) => x.type.code === "lstudio")}
          />
        </OverviewTabContent>
      ),
    },
  ];

  useEffect(() => {
    findDashboards();
    trackEvent({
      page: "dashboards-overview",
      event: "page-load",
    });
  }, []);

  return (
    <OverviewComponent
      breadcrumbItems={breadcrumbItems}
      options={SearchInputComponent}
      tabs={dashboardsTabs}
    >
      <OverviewTabContent
        value="all"
        title="dashboards.overview.card.title"
        description="dashboards.overview.card.description"
      >
        <DashboardsOverviewTable data={dashboards} />
      </OverviewTabContent>
    </OverviewComponent>
  );
};

export default DashboardsOverview;
